import {toPriceStr} from '@/utils';

export const SPIN_NAME = 'spin-actual';
export const SPIN_IMAGES = [
  require('@/assets/imgs/spin-actual/spin-bg.webp'),
  require('@/assets/imgs/spin-actual/spin-pic.webp'),
  require('@/assets/imgs/spin-actual/spin-wrap.webp'),
  require('@/assets/icons/spin-actual/btn-recharge.webp'),
];

export const DEFAULT_PRIZE_LIST = [
  {
    name: 'iPhone 16 PRO',
    pic: '',
    isActual: true,
  },
  {
    name: 'OnePlus Buds Pro 3',
    pic: '',
    isActual: true,
  },
  {
    name: 'ONEPLUS 13R',
    pic: '',
    isActual: true,
  },
  {
    name: '1 Gram Gold Coin',
    pic: '',
    isActual: true,
  },
  {
    name: 'Spinsx2',
    pic: '',
    isActual: false,
  },
  {
    name: 'Spinsx1',
    pic: '',
    isActual: false,
  },
  {
    name: toPriceStr(50, {fixed: 0}),
    pic: '',
    isActual: false,
  },
  {
    name: toPriceStr(20, {fixed: 0}),
    pic: '',
    isActual: false,
  },
];
